import React from "react";
import FontAwesome from "react-fontawesome";

export default React.createClass({
  render: function() {
    return (
      <div key={this.props.label} className={"form-row checklist-row" + (this.props.ready ? "" : " disabled")}>
        <span className="form-label">
          {this.props.status &&
            <FontAwesome className="application-toggle green" name="check"/>
          }
          {!this.props.status &&
            <FontAwesome className="disabled" name="times"/>
          }
        </span>
        <span className="form-value">
          <strong>{this.props.label}</strong>
          {!this.props.status &&
            <div className="description">
              {this.props.offDescription} {this.props.action}
            </div>
          }
        </span>

      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/js/components/account/checklist-row.jsx